import React from 'react';
import { Fragment, useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next/hooks';

import Button from '../../Button/Button';
import Loader from '../../Loader/Loader';

import { useStore } from '../../../hook-store/store';
import { 
  acceptGroupInvitation,
  updateGroupInvitationLastOpenAt,
} from '../../../util/group/group-invitation';

import { SOCKET_GROUP_URL } from '../../../App';

import { marks } from '../../../images/marks';
import '../../../pages/GroupTalk/GroupTalk.css';
import './GroupInvitation.css';

const InvitedGroupList = (props) => {
  // console.log('grouplistItem.js props', props);

  const { 
    group,
    usersData,
    userId,
    isLoading,

  } = props;

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { userGroupInvitation } = store.groupStore;

  const [showInvitationList, setShowInvitationList] = useState(false);
  const [isInvitationOpen, setIsInvitationOpen] = useState(false);

  const [isDataLoading, setIsDataLoading] = useState(false);


  useEffect(() => {
    if (showInvitationList && !isInvitationOpen) {
      setIsInvitationOpen(true);
      updateInvitationLastOpenAtHandler();
    }
  },[showInvitationList, isInvitationOpen]);

  const updateInvitationLastOpenAtHandler = async () => {
    try {
      const resData = await updateGroupInvitationLastOpenAt(
        SOCKET_GROUP_URL, 
        localStorage.getItem('token'),
      );

      if (resData.data) {
        dispatch('SET_USERGROUPINVITATION', resData.data);
      }

    } catch(err) {
      console.log(err);
      throw err;
    }
  };

  const acceptGroupInvitationHandler = async (groupRoomId) => {
    try {
      setIsDataLoading(true);

      const resData = await acceptGroupInvitation(
        SOCKET_GROUP_URL,
        localStorage.getItem('token'),
        groupRoomId,
      );

      if (resData) {
        const deletedInvitations = userGroupInvitation.invitedGroupRoomIds.filter(ele => {
          return ele.groupRoomId !== groupRoomId;
        });

        dispatch('SET_USERGROUPINVITATION', {
          ...userGroupInvitation,
          invitedGroupRoomIds: deletedInvitations,
        });

        dispatch('SHOW_NOTIFICATION', {
          // status: 'pending',
          //   title: '',
          message: 'group accept success',
        });
  
        setTimeout(() => {
          dispatch('CLEAR_NOTIFICATION');
          window.location.reload();
        },1000*5);

      }

      setIsDataLoading(false);
    } catch(err) {
      console.log(err);
      setIsDataLoading(false);
      throw err;
    }
  };


  let invitedGroupListBody;

  if (userGroupInvitation?.invitedGroupRoomIds?.length > 0) {
    let newInvitations = 0;

    for (const invitation of userGroupInvitation.invitedGroupRoomIds) {
      if (!userGroupInvitation.lastOpenAt) {
        newInvitations = newInvitations + 1;
      } else {
        if (invitation.addAt > userGroupInvitation.lastOpenAt) {
          newInvitations = newInvitations + 1;
        }
      }
    }
    
    invitedGroupListBody = (
      <div>
        <div className="groupInivitationRow">
          <div className="groupInivitationTitle">
            <strong
              onClick={() => { 
                setShowInvitationList(!showInvitationList);
              }}
            >
              <span>
                {t('groupTalk.text64', 'Group invitations for you')}
              </span>
              {' '}
              {!isInvitationOpen && newInvitations > 0 && (
                <span className="groupInvitationNewMark">
                  New ({newInvitations})
                </span>
              )}
              {' '}{marks.triangleDown} 
            </strong>
          </div>
        </div>
        {showInvitationList && (
          <div>
            <div  className="groupInivitationRow">
              <div className='groupInvitationMessage'>
                {t('groupTalk.text65', 'If you are not sure about these invitations, please ignore.')}
                {' '}
                {t('groupTalk.text66', 'After accepting invitation, you can access the group.')}
              </div>
            </div>
            <div>
              <ul className='groupInvitationList'>
                {userGroupInvitation.invitedGroupRoomIds.reverse().map(element => {
                  return (
                    <li className='groupInvitationListItem'
                      key={element.groupRoomId}
                    >
                      <div>
                        <div>
                          {t('groupTalk.text67', 'Group name')}:{' '}
                          <strong>
                            {element.groupName}
                          </strong>
                        </div>
                        <div>
                          {t('groupTalk.text68', 'Group creator email')}:{' '}
                          <strong>
                            {element.creatorEmail}
                          </strong>
                        </div>
                        <div>
                          {t('groupTalk.text69', 'time')}:{' '}
                          <strong>
                            {new Date(element.addAt).toLocaleDateString()}
                          </strong>
                        </div>
                        <span>
                          <Button
                            mode="raised" design="" type="submit" size='smaller'
                            disabled={isDataLoading}
                            onClick={() => {
                              acceptGroupInvitationHandler(element.groupRoomId);
                            }}
                          >
                            {t('groupTalk.text70', 'Accept invitation')}
                          </Button>
                        </span>
                        {isDataLoading && (
                          <Loader />
                        )}
                      </div>
                    </li>
                  )
              })}
              </ul>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
      <Fragment>
        <div>
          {invitedGroupListBody}
        </div>
      </Fragment>
  );
}

export default InvitedGroupList;